export type ProfitLossDirection = "profit" | "loss" | "flat";

export function profitLossDirection(value: number): ProfitLossDirection {
  if (!Number.isFinite(value)) return "flat";
  if (value > 0) return "profit";
  if (value < 0) return "loss";
  return "flat";
}
